import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  // Hide footer on dashboard and admin pages
  if (location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/admin')) {
    return null;
  }

  return (
    <footer className="footer-shell">
      <div className="footer-max">
        <div className="footer-brand">
          <div className="footer-logo">TikPlat</div>
          <p className="footer-copy">
            Premium ticketing for concerts, theater, sports, and cultural events. Built with security-first
            payments, encrypted tickets, and real-time seat maps.
          </p>
          <div className="footer-meta">© {currentYear} TikPlat. All rights reserved.</div>
        </div>

        <div className="footer-grid">
          <div className="footer-column">
            <p className="footer-heading">Legal</p>
            <Link to="/legal#terms" className="footer-link">Terms of Service</Link>
            <Link to="/legal#privacy" className="footer-link">Privacy Policy</Link>
            <Link to="/legal#cookies" className="footer-link">Cookie Policy</Link>
            <Link to="/legal#refunds" className="footer-link">Refunds & Cancellations</Link>
            <Link to="/legal#compliance" className="footer-link">Compliance Statement</Link>
          </div>

          <div className="footer-column">
            <p className="footer-heading">Trust & Safety</p>
            <Link to="/legal#security" className="footer-link">Security</Link>
            <Link to="/legal#payments" className="footer-link">Payments & PCI</Link>
            <Link to="/legal#tickets" className="footer-link">Digital Tickets</Link>
          </div>

          <div className="footer-column">
            <p className="footer-heading">Support</p>
            <a className="footer-link" href="mailto:support@tikplat.com">support@tikplat.com</a>
            <a className="footer-link" href="mailto:legal@tikplat.com">legal@tikplat.com</a>
            <span className="footer-link muted">Response: <strong>&lt;24h</strong> on business days</span>
          </div>

          <div className="footer-column">
            <p className="footer-heading">Opportunities</p>
            <Link to="/roles/promoter" className="footer-link">Request to be a promoter</Link>
            <Link to="/roles/staff" className="footer-link">Request to be staff</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
